import React from 'react';
import { Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useTooltipStyles = makeStyles((theme) => ({
  text: {
    fontSize: theme.typography.fontSize
  }
}));

type TooltipLabelProp = {
  id?: string;
  name?: string;
  value?: string | number;
};

export const SmartDiaryTooltip: React.FC<TooltipLabelProp> = ({
  id,
  name,
  value
}: TooltipLabelProp) => {
  const tooltipStyleClasses = useTooltipStyles();
  return (
    <div>
      <Typography
        className={tooltipStyleClasses.text}
        data-testid={`label_tooltip_name_${id}`}
      >
        {name && <b>{name}: </b>}
        {value}
      </Typography>
    </div>
  );
};
